import { useMemo } from 'react';

import SortAndFilterConfig, { SortMethods } from '../../../../../modules/sortAndFilter/config/SortAndFilterConfig';

/**
 * Uses the config to order the sort options in order they should be shown in the UI. It will also remove any
 * disabled sorting options.
 */
const useFormatSortingOptions = (config: SortAndFilterConfig) => {
    const filteredOptions = useMemo(() => {
        const options = (Object.keys(config.sorting.options) as SortMethods[])
            .filter((key) => config.sorting.options[key]?.enabled)
            .sort((a, b) => {
                const aValue = config.sorting.options[a]?.order || 0;
                const bValue = config.sorting.options[b]?.order || 0;

                return aValue - bValue;
            });

        return options;
    }, [config]);

    return filteredOptions;
};

export default useFormatSortingOptions;
